'use client'

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import '@splidejs/react-splide/css'
import '@/public/css/splide-custom.css'
import { motion } from 'motion/react'
import Link from 'next/link'

const SlideData = [
    {
        image: '/images/slide1Image.jpg',
        heading: 'Let Us Do The Work For You',
        subheading:
            'Leading online post office, providing thousands of individuals and businesses around the world with flexible mail solutions',
        buttonText: 'Get Started',
        buttonLink: '#',
    },
    {
        image: '/images/slide2Image.jpg',
        heading: 'Let Us Help You With Your Relationships',
        subheading:
            'We keep the spark alive in your relationships by making it easier to prove your love with gifts, cards, etc.',
        buttonText: 'Get Started',
        buttonLink: '#',
    },
    {
        image: '/images/slide3Image.jpg',
        heading: 'Let Us Help You Reach All Your Customers',
        subheading:
            'Trusted online post office, providing access to all your customers using mailing lists and address books',
        buttonText: 'Get Started',
        buttonLink: '#',
    },
]

const HomeCarousel = () => {
    return (
        <>
            <Splide
                options={{
                    autoplay: true,
                    type: 'loop',
                    perPage: 1,
                    interval: 5000,
                    speed: 1500,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                }}
                hasTrack={false}
                aria-label="React Splide Example"
            >
                <div>
                    <div className="splide__progress">
                        <div className="splide__progress__bar" />
                    </div>

                    <SplideTrack>
                        {SlideData.map((slide, index) => (
                            <SplideSlide key={index}>
                                <div
                                    className="relative bg-cover bg-center h-[400px] lg:h-[500px] xl:h-[600px]"
                                    style={{
                                        backgroundImage: `url(${slide.image})`,
                                    }}
                                >
                                    <div className="slide-item-data flex size-full items-center justify-center px-16 sm:px-20">
                                        <div className="slide-data-contents z-10 text-center font-maven-pro text-white">
                                            <h2 className="heading-text text-2xl uppercase font-black sm:text-4xl lg:text-[46px] text-shadow-[4px_2px_2px_#333] animate-in slide-in-from-left-full duration-3600">
                                                {slide.heading}
                                            </h2>
                                            <h3 className="subheading-text text-lg font-normal mt-[1rem] sm:text-2xl lg:text-[20px] animate-in slide-in-from-right-full duration-3600 delay-500">
                                                {slide.subheading}
                                            </h3>
                                            <motion.p
                                                initial={{
                                                    opacity: 0,
                                                    y: '100%',
                                                }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{
                                                    duration: 2.2,
                                                    delay: 1,
                                                    ease: [0, 0.71, 0.2, 1],
                                                }}
                                                className="mt-8 font-montserrat"
                                            >
                                                <Link
                                                    href={slide.buttonLink}
                                                    className="px-6 py-4 sm:px-9 sm:py-5 border border-white inline-block font-bold bg-[#ffffffaa] text-[#374785] hover:bg-white hover:text-[#374785] text-xs uppercase mr-4"
                                                >
                                                    {slide.buttonText}
                                                </Link>
                                            </motion.p>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))}
                    </SplideTrack>

                    <div className="splide__arrows">
                        <button className="splide__arrow splide__arrow--prev !w-[60px] sm:!w-[80px]">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 40 40"
                                width="40"
                                height="40"
                            >
                                <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                            </svg>
                        </button>
                        <button className="splide__arrow splide__arrow--next !w-[60px] sm:!w-[80px]">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 40 40"
                                width="40"
                                height="40"
                            >
                                <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </Splide>
        </>
    )
}

export default HomeCarousel
